<template lang="pug">
  section
    h2.heading Activity History

    table.activity-list
      thead
        tr
          th.date Date
          th.activity Activity
          th.status Status
          th.rating Rating
      tbody
        tr(v-if="!activities || activities.length == 0")
          td(colspan="4")
            | No activities completed
        tr(v-for="(act, idx) in activities")
          td.date
            span(v-if="showDate(idx)") {{ act.modifiedOn|shortDate }}
          td.activity
            img(:src="act.imageUrl + '?fit=crop&crop=center&w=200&h=200&auto=format,enhance'" alt="Activity thumbnail" type="smallSquare")
            a(:href="getActivityUrl(act)" target="_blank") {{act.title}}
          td.status(v-if="act.favorite")
            svg.svgicon(xmlns='http://www.w3.org/2000/svg', viewbox='0 0 16 16')
              title Favorite
              path(d='M15.18,5.46a.91.91,0,0,1,.61.36,1,1,0,0,1,.21.66.92.92,0,0,1-.28.63l-3.17,3.08.75,4.37a.94.94,0,0,1-.13.67.88.88,0,0,1-.55.4.92.92,0,0,1-.69-.09L8,13.5l-3.92,2a.92.92,0,0,1-.69.09.88.88,0,0,1-.55-.4.94.94,0,0,1-.13-.67l.75-4.37L.29,7.1A.92.92,0,0,1,0,6.47a1,1,0,0,1,.21-.66.91.91,0,0,1,.61-.36l4.37-.63L7.13.88A.91.91,0,0,1,7.66.4a1,1,0,0,1,.69,0,.91.91,0,0,1,.52.48l1.94,3.95ZM11,9.67l3-2.93-4.16-.6L8,2.38,6.15,6.15,2,6.74,5,9.67l-.69,4.16,3.71-2,3.71,2Z')
            | Favorited
          td.status(v-else-if="act.skipped")
            svg.svgicon(xmlns='http://www.w3.org/2000/svg', viewbox='0 0 16 16')
              title Skipped
              path(d='M9.73,8l5.64,5.64a.63.63,0,0,1,.13.39.47.47,0,0,1-.13.35l-1,1a.47.47,0,0,1-.35.13.63.63,0,0,1-.39-.13L8,9.73,2.36,15.37A.63.63,0,0,1,2,15.5a.47.47,0,0,1-.35-.13l-1-1A.47.47,0,0,1,.5,14a.63.63,0,0,1,.13-.39L6.27,8,.63,2.36A.63.63,0,0,1,.5,2a.47.47,0,0,1,.13-.35l1-1A.47.47,0,0,1,2,.5a.63.63,0,0,1,.39.13L8,6.27,13.64.63A.63.63,0,0,1,14,.5a.47.47,0,0,1,.35.13l1,1A.47.47,0,0,1,15.5,2a.63.63,0,0,1-.13.39Z')
            | Skipped
          td.status(v-else)
            svg.svgicon(xmlns='http://www.w3.org/2000/svg', viewbox='0 0 16 16')
              title Taken
              path(d='M14.29,2a.38.38,0,0,1,.28-.1.51.51,0,0,1,.31.1l1,1a.33.33,0,0,1,.14.28.43.43,0,0,1-.14.31L5.38,14a.38.38,0,0,1-.28.1.51.51,0,0,1-.31-.1L.14,9.36A.33.33,0,0,1,0,9.08a.43.43,0,0,1,.14-.31l1-1a.43.43,0,0,1,.31-.14.33.33,0,0,1,.28.14L5.1,11.18Z')
            | Taken
          td.rating {{ act.rating !== null && !isNaN(act.rating) && act.rating !== 50 ? act.rating : '--' }}

</template>

<script>
import auth from '@/services/authSvc.js';

export default {
  name: 'PatientActivity',
  props: ['activities'],
  methods: {
    showDate(idx) {
      const shortDate = this.$options.filters.shortDate;
      if (idx === 0) {
        return true;
      }
      return shortDate(this.activities[idx].modifiedOn) !== shortDate(this.activities[idx - 1].modifiedOn);
    },
    getActivityUrl(activity) {
      let url = auth.getWebuiUrl();
      url += `/activity/${activity.activityUrl}`;
      return url;
    }
  }
};
</script>
<style lang="scss" scoped>
  .activity-list {
    td {
      white-space: pre-wrap;
    }
    td.date {
      border: none;
      font-weight: $base-font-weight-strong;
    }
    .date {
      width: 15%;
    }
    .activity {
      width: 55%;
      img {
        @include size(40px);
        margin-right: $small-spacing;
      }
    }
    .status {
      width: 20%;
      .svgicon {
        @include size(16px);
        margin-right: $xs-spacing;
      }
    }
    .rating {
      width: 10%;
      text-align: right;
    }
  }
</style>
